import { FarmboxRawMaterials } from "models/FarmboxRawMaterials/farmBoxRawMaterials.model"

export const resetOriginsToEmptyArray = (item: FarmboxRawMaterials) => {
    if (!item?.multiOrigin) {
        item.origins = []
        item.id ??= undefined
    }
}